module.exports = __webpack_public_path__ + "images/company/rank_medal/average_seconds_to_initial_reply_rank/5_9d86d027ea25c0b13aa4c83c5dda97a0.png";